<template>
  <svg class="logo-container" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 883.62 285.64">
  <!-- <defs> -->
    <!-- <style>
      .cls-1 {
        fill: #fff;
      }
    </style> -->
  <!-- </defs> -->
  <title>MT logo (white)</title>
  <g>
      <!-- eslint-disable max-len -->
    <path class="micro-logo" d="M891.48,336c-37-21.69-74.44-43.79-117.16-51.72-41.11-7.64-82.5,4.14-119.08,22.64-38.91,19.68-75,44.68-114.56,63-19.17,8.88-39.24,15.5-60.16,18.6-20.24,3-40.77,1.31-60.62-3.3-42.4-9.84-80.25-34.57-117.32-56.32-36.21-21.25-74.17-41.52-116.53-46.2C144,278.09,103.44,293.36,67,312.84,53,320.3,39.65,328.59,26.24,337c-6.73,4.22-11.7,11.23-18.38,15.43C43.61,330,82.13,306.54,124.55,299.78c20.1-3.2,40.66-3.36,60.62,1.07,21.64,4.81,41.87,13.09,61.7,22.88,38.18,18.86,72.87,44.47,111.89,61.72C378,394,398,401.47,419,404c20.25,2.46,40.8,1.73,60.63-3.37,41.64-10.73,78-33.6,114.83-54.95C631,324.55,670.07,301.74,713,298.17c20.37-1.69,40.92-.25,60.62,5.5,21.06,6.15,40.69,15.15,60.09,25.3,13.37,7,26.33,14.83,39.34,22.46.68.4,8.62-7.08,9.27-7.62s8.69-8.06,9.12-7.81Z" transform="translate(-7.86 -157.03)"/>
    <path class="micro-logo" d="M7.86,352.87C44.45,329.09,81,305.06,120.8,287c38.73-17.56,80.58-27,123.15-23.29,42.78,3.73,82.49,21.24,119.78,41.5,37.85,20.56,72.94,45.87,109.35,68.78,36.84,23.18,74.36,44.77,115.93,58.29,41,13.34,84,13.32,125.59,2.87,42.12-10.6,80.72-33.11,117.33-55.76,13.87-8.59,27.51-17.59,41.16-26.52,6.66-4.36,11.76-11.09,18.39-15.43-36,23.55-72.26,48-111.77,65.35-38.82,17-80.81,28.32-123.55,23.89C613.76,422.3,574,406.57,537,385.86c-38.36-21.47-74.46-46.54-111.57-70-36.24-23-73.86-45.09-115.1-57.76s-84.22-13.91-126.07-2.75c-40.82,10.88-78.83,31.6-114.36,54-14.64,9.25-29.15,18.67-43.67,28.1-6.67,4.34-11.75,11.12-18.38,15.43Z" transform="translate(-7.86 -157.03)"/>
    <path class="micro-logo" d="M7.86,352.87C44.3,329.12,80.58,305,117.94,282.75c37.91-22.62,76.46-44.15,116.84-62.1,39.87-17.72,81.14-31.57,124-40.11,41.63-8.3,84.16-9.51,126.34-5.54,42.34,4,84.65,15.24,124.27,30.49,41,15.8,80.37,35.19,118.65,56.8,37.21,21,73.35,43.87,109.17,67.16q18,11.69,35.92,23.42c.58.37,8.67-7.12,9.27-7.63s8.78-8,9.12-7.8c-36-23.56-72-47.32-108.94-69.43-38-22.74-76.69-44.31-117.16-62.42a597,597,0,0,0-122.82-40.11,408.93,408.93,0,0,0-125.83-6.15,508,508,0,0,0-125.52,30.28c-41.19,15.65-80.6,35.16-119,56.74-36.55,20.56-72.09,43-107.22,65.83L26.24,337.44c-6.67,4.34-11.75,11.1-18.38,15.43Z" transform="translate(-7.86 -157.03)"/>
  </g>
</svg>

</template>

<script>

export default {
  name: 'MTlogo',
};
</script>

<style>
.micro-logo {
    /* fill: #fff; */
    fill: white;
}

.logo-container {
    width: 60px;
    height: 44px;
}

</style>
